
                            const shader = `precision highp float;

uniform vec2 uResolution;
uniform float uDarkMode;

varying vec2 vUv;

void main() {
	vec2 sUv = gl_FragCoord.xy / uResolution;
	float dtc = length(sUv - vec2(0.5));

	vec3 color = mix(vec3(0.89), vec3(0.3), dtc);
	color = mix(color, vec3(0.1 - dtc * 0.1), uDarkMode);
	gl_FragColor = vec4(color, 1.);
}
`;

                            export default {
                                use: (el) => {
                                    const instance = el.material || el;
                                    instance['fragmentShader'] = shader;
                                    instance.needsUpdate = true;
                                    return el;
                                }
                            }
                        